export default "__VITE_ASSET__Cvn4479u__"